import {compose, createStore} from "redux";
import {combineReducers} from "@reduxjs/toolkit";
import editor from "./slices/editor";
import firebase from "./slices/firebase";

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
export const store = createStore(
    combineReducers({
        editor,
        firebase
    }),
    composeEnhancers()
);